import React from "react";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";

const RELATED_SERVICES = [
  {
    key: "related_service_platform",
    url: "https://ai-prop.com",
    gaLabel: "Related Service AI-Prop Platform",
    isExternal: false,
  },
  {
    key: "related_service_virtual_staging",
    url: "https://virtual-staging.ai-prop.com/",
    gaLabel: "Related Service Virtual Staging",
    isExternal: true,
  },
  {
    key: "related_service_item_removal",
    url: "https://item-removal.ai-prop.com/",
    gaLabel: "Related Service Item Removal",
    isExternal: true,
  },
  {
    key: "related_service_photo_shooting",
    url: "https://photo.tanomo.asia/",
    gaLabel: "Related Service Photo Shooting",
    isExternal: true,
  },
];

export const RelatedServices = () => {
  const { t } = useTranslation();
  return (
    <div id="relatedServices">
      {RELATED_SERVICES.map((service) => (
        <a
          key={service.key}
          href={service.url}
          target={service.isExternal ? "_blank" : undefined}
          rel={service.isExternal ? "noopener noreferrer" : undefined}
          onClick={() => {
            ReactGA.event({
              category: "Navigation",
              action: "Click",
              label: service.gaLabel,
            });
          }}
        >
          <span className="arrow">›</span>
          <span>{t(service.key)}</span>
        </a>
      ))}
    </div>
  );
};
